export default __webpack_public_path__ + "static/media/magento.a62a906a.svg";